<template>
  <div class="mt-20">
    <!-- Hero/Landing -->
    <div
      class="w-full min-h-screen scoped-hero-bg flex flex-wrap lg:flex-nowrap items-center gap-12 pl-12 lg:pl-32 2xl:pl-64"
    >
      <div
        class="w-full lg:w-1/2 text-white flex flex-col justify-center pr-12 lg:pr-0"
      >
        <!-- <h5 class="mb-4 uppercase">Join CareerWise</h5> -->
        <h1 class="hidden md:block mb-12">{{ PAGE_TITLE }}</h1>
        <h2 class="md:hidden my-12">{{ PAGE_TITLE }}</h2>
        <p class="mb-8">
          With Connections, your students can now access an exclusive school
          network of parents and professionals ready to share their career
          journeys, insights, and advice. This powerful tool helps students
          build meaningful connections, gain valuable career inspiration, and
          start their path to success.
        </p>
        <div class="flex flex-col md:flex-row gap-4">
          <button
            class="btn btn-cw-alt h-10 px-4 mb-2"
            @click="toggleCwRegistration(1)"
          >
            Request Demo
          </button>
          <button
            class="btn btn-trans-white h-10 px-4 mb-0"
            @click="scrollTo(registerSection)"
          >
            Register Now
          </button>
        </div>
      </div>
      <div class="w-full lg:w-1/2 text-white lg:flex flex-col justify-center">
        <img
          src="/img/connections/images/connections-hero.png"
          alt="Connections Hero Icon"
        />
      </div>
    </div>
    <!-- /Hero/Landing -->

    <!-- Head Start -->
    <div class="flex items-center justify-center">
      <div
        class="flex items-center justify-center max-w-6xl flex-wrap lg:flex-nowrap gap-12 lg:gap-16 py-32 px-8"
      >
        <div
          class="w-full lg:w-1/2 flex flex-col justify-center text-center lg:text-left"
        >
          <h1 class="hidden md:block mb-12 text-cw-900">
            {{ SECTION_TITLE_HEAD_START }}
          </h1>
          <h2 class="md:hidden mb-12 text-cw-900">
            {{ SECTION_TITLE_HEAD_START }}
          </h2>
          <p>
            We all remember that person who influenced our career path in those
            early days. The importance of role models and network in inspiring
            and successfully navigating career pathways cannot be understated.
          </p>
        </div>
        <div class="w-full lg:w-1/2">
          <img
            class="w-full rounded-xl"
            src="/img/cw-marketing/connections-people-are-the-main-influencers.jpg"
            alt="Group of people"
          />
        </div>
      </div>
    </div>
    <!-- /Head Start -->

    <!-- People -->
    <div
      :style="{
        backgroundImage: 'url(/img/cw-marketing/connections-subhero.png)',
      }"
      class="bg-center bg-cover flex items-center justify-center px-8 lg:px-0 py-32 overlay"
    >
      <div class="w-full lg:w-1/2 flex flex-col items-center justify-center">
        <h1 class="hidden md:block mb-12 text-center text-white">
          {{ SECTION_TITLE_PEOPLE }}
        </h1>
        <h2 class="md:hidden mb-12 text-center text-white">
          {{ SECTION_TITLE_PEOPLE }}
        </h2>
        <p class="text-center text-white">
          Connections enhances parent engagement and strengthens your school's
          network by making it easy for parents and organisations to get
          involved. With Connections, your students have exclusive access to a
          powerful school network of parents and organisations eager to share
          their career journeys and inspire the next generation.
        </p>
      </div>
    </div>
    <!-- /People -->

    <!-- Ways to connect -->
    <div class="px-6 md:px-16 lg:px-24 xl:px-32 py-16 bg-white">
      <div class="flex flex-col items-center justify-center mb-12 lg:mb-24">
        <div class="w-full lg:w-1/2">
          <h1 class="hidden md:block text-center text-cw-900">
            {{ SECTION_TITLE_CONNECT }}
          </h1>
          <h2 class="md:hidden text-center text-cw-900">
            {{ SECTION_TITLE_CONNECT }}
          </h2>
          <p class="text-center text-truegray-700">
            From webinars to classroom talks, parents and businesses can share
            insights and guidance, creating meaningful opportunities for
            students to learn from real-life experiences.
          </p>
        </div>
      </div>
      <CardGroupHover />
    </div>
    <!-- /Ways to connect -->

    <!-- Report -->
    <!--
      <div
      class="flex flex-col items-center justify-center gap-24 py-20 md:py-32 px-8 lg:px-12 w-full overflow-hidden bg-cw-500 relative"
      >
      <div
      class="flex flex-wrap lg:flex-nowrap justify-center gap-24 w-full max-w-6xl text-white"
      >
      <img
      class="absolute w-full lg:w-1/2 opacity-10 filter brightness-0 invert"
      :style="{ left: '-20px', top: '45%' }"
      src="/img/cw-marketing/cw-shapes_dots.svg"
      alt="CW alt shapes"
      />
      <div
      class="flex flex-col justify-center gap-2 w-full lg:w-7/12 pr-0 lg:pr-20 relative"
      >
      <p>
      It's no surprise therefore that the TEC has confirmed in their most
      recent report that people—<span class="italic"
      >not websites, TV shows, social media, and the like</span
      >—are the primary influencers of young people's career decisions.
      </p>
      <p class="mb-10">
      Unfortunately, everyone's personal networks are not created equal,
      and serendipity does not step in for everyone.
      </p>
      <h2 class="hidden md:block text-white mb-8">
      {{ SECTION_TITLE_REPORT }}
      </h2>
      <h3 class="md:hidden text-white mb-8">
      {{ SECTION_TITLE_REPORT }}
      </h3>
      <p>
      With CareerWise Connections, every student has access to the wider
      school network of parents within a school community who are keen to
      represent their careers to the next generation.
      </p>
      </div>
      <div class="hidden lg:block w-5/12 relative">
      <img
      src="/img/cw-marketing/connections-report-graphic.png"
      alt="Connections Report"
      class="absolute w-full"
      />
      </div>
      </div>
      </div> 
    -->
    <!-- /Report -->

    <!-- Who It's For -->
    <div class="pt-24 flex flex-col items-center bg-cw-50">
      <h2 class="text-cw-900 text-center mb-2">Who's it for?</h2>
      <p class="text-center text-cw-900">
        The Connections feature is FREE for the CareerWise customer community.
        If you are not yet part of the community, get in touch!
      </p>
    </div>
    <div class="bg-cw-50 md:px-8 py-12 flex items-center justify-center">
      <div class="max-w-6xl flex flex-col justify-center">
        <CardGroup
          :four-columns="true"
          :is-centered="true"
          :list="LIST_WHO_ITS_FOR"
        />
      </div>
    </div>
    <!-- /Who It's For -->

    <!-- Used By -->
    <div
      class="py-32 relative flex items-center justify-center overflow-hidden"
    >
      <img
        class="absolute right-0 w-full lg:w-1/3 opacity-10"
        :style="{ top: '-250px' }"
        src="/img/cw-marketing/cw-shapes_dots.svg"
        alt="CW alt shapes"
      />
      <div
        class="w-full lg:max-w-6xl flex flex-col gap-24 px-12 md:px-10 lg:px-0"
      >
        <div
          class="flex flex-wrap gap-2 md:gap-12 items-center justify-center md:justify-start"
        >
          <h1 class="text-center text-cw-900 m-0">Used by</h1>
          <h1
            class="bg-cw-50 m-0 flex items-center justify-center p-4 text-cw-900 rounded-xl cursor-pointer relative hover:text-cw-300"
            @click="toggleUserTypeDropdown"
          >
            {{ activeUserTypeData.context }}
            <span class="text-cw-300 ml-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                class="w-10 h-10"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
            <div
              :class="
                userTypeDropdownActive
                  ? 'opacity-100'
                  : 'opacity-0 pointer-events-none'
              "
              :style="{ marginTop: '-10px' }"
              class="flex flex-col gap-4 bg-cw-50 absolute left-0 top-full z-20 transition-all opacity-100 rounded-b-xl p-6"
            >
              <div
                v-for="(type, i) in LIST_USER_TYPES"
                :key="i"
                class="text-cw-900 hover:text-cw-300"
                @click="selectUserType(i)"
              >
                <h3 class="text-cw-900 hover:text-cw-300 mb-0">
                  {{ type.context }}
                </h3>
              </div>
            </div>
          </h1>
        </div>

        <div
          :class="userTypeContentActive ? 'opacity-100' : 'opacity-0'"
          class="flex flex-col gap-12 md:gap-24 transition-all"
        >
          <div
            class="gap-16 flex flex-wrap lg:flex-nowrap items-center justify-center xl:justify-between"
          >
            <div class="w-full lg:w-1/2">
              <h3 class="text-cw-900 pr-0 lg:pr-12">
                {{ activeUserTypeData.title1 }}
              </h3>
              <p class="mb-6 text-truegray-700">
                {{ activeUserTypeData.text1 }}
              </p>
              <div
                :style="{ width: 'max-content' }"
                class="btn btn-black m-0"
                @click="toggleCwRegistration(1)"
              >
                {{ activeUserTypeData.cta1 }}
              </div>
            </div>
            <div
              class="hidden lg:block w-full lg:w-1/2 flex items-center justify-center max-w-md"
            >
              <img :src="activeUserTypeData.image1" class="rounded-xl" />
            </div>
          </div>

          <div
            class="gap-16 flex flex-wrap lg:flex-nowrap items-center justify-center xl:justify-between"
          >
            <div
              class="hidden lg:block w-full lg:w-1/2 flex items-center justify-center max-w-md"
            >
              <img :src="activeUserTypeData.image2" class="rounded-xl" />
            </div>
            <div class="w-full lg:w-1/2">
              <h3 class="text-cw-900 pr-0 lg:pr-12">
                {{ activeUserTypeData.title2 }}
              </h3>
              <p class="text-truegray-700">
                {{ activeUserTypeData.text2 }}
              </p>
              <!--
                <div
                :style="{ width: 'max-content' }"
                class="btn btn-black m-0"
                @click="toggleCwRegistration(1)"
                >
                Case Studies(?)
                </div> 
              -->
            </div>
          </div>

          <div
            class="gap-16 flex flex-wrap lg:flex-nowrap items-center justify-center xl:justify-between"
          >
            <div class="w-full lg:w-1/2">
              <h3 class="text-cw-900 pr-0 lg:pr-12">
                {{ activeUserTypeData.title3 }}
              </h3>
              <p class="text-truegray-700">
                {{ activeUserTypeData.text3 }}
              </p>
              <div
                v-if="isActiveUserTypeParents"
                :style="{ width: 'max-content' }"
                class="btn btn-black m-0 mt-6"
                @click="toggleCwRegistration(0)"
              >
                Enquire now
              </div>
            </div>
            <div
              class="hidden lg:block w-full lg:w-1/2 flex items-center justify-center max-w-md"
            >
              <img :src="activeUserTypeData.image3" class="rounded-xl" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Used By -->

    <!-- Apply -->
    <div
      ref="registerSection"
      class="py-20 px-8 lg:px-12 flex items-center justify-center w-full overflow-hidden cw-gradient"
    >
      <div
        class="flex w-full max-w-6xl flex-wrap lg:flex-nowrap text-white justify-center relative"
      >
        <img
          src="/img/cw-marketing/cw-shapes_dots.svg"
          alt="CW alt shapes"
          class="absolute left-0 top-1/2 w-full lg:w-1/3 opacity-10 filter brightness-0 invert"
        />
        <div
          class="w-10/12 lg:w-5/12 lg:pr-44 relative flex flex-col justify-center"
        >
          <h2 class="hidden md:block text-white mb-8">
            Apply to be a national connection
          </h2>
          <h3 class="md:hidden text-white mb-8">
            Apply to be a national Connection
          </h3>
          <p class="text-white">Register as...</p>
        </div>
        <div
          class="flex-col md:flex-row w-10/12 lg:w-7/12 py-8 lg:py-0 flex gap-12 z-10"
        >
          <div
            class="w-full lg:w-1/2 rounded-xl bg-white p-6 flex flex-col items-center justify-center"
          >
            <img
              src="/img/cw-marketing/outline-unis.png"
              alt="Parents"
              class="mb-6 h-36"
            />
            <h4 class="text-cw-900 mb-6 text-center">Tertiary Institutions</h4>
            <p class="text-center text-cw-900 mb-6">
              Share career inspiration directly with New Zealand's senior school
              students.
            </p>
            <button
              class="btn btn-black w-full mb-0 mt-auto"
              @click="register('organisation')"
            >
              Register
            </button>
          </div>
          <div
            class="w-full lg:w-1/2 rounded-xl bg-white p-6 flex flex-col items-center justify-center"
          >
            <img
              src="/img/cw-marketing/outline-businesses.png"
              alt="Organisations"
              class="mb-6 h-36"
            />
            <h4 class="text-cw-900 mb-6 text-center">
              Employers and trade associations
            </h4>
            <p class="text-center text-cw-900 mb-6">
              Tap directly into a New Zealand's talent pipeline and inspire the
              next generation with career inspiration from your sector.
            </p>
            <button
              class="btn btn-cw-alt w-full mb-0 mt-auto"
              @click="register('organisation')"
            >
              Register
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /Apply -->

    <!-- Connect Educate Inspire -->
    <!--
      <div
      :style="{
      backgroundImage: 'url(/img/cw-marketing/connections-cei.jpg)',
      }"
      class="bg-center bg-cover flex items-center justify-center px-8 lg:px-0 py-32 overlay-40"
      >
      <div class="w-full lg:w-1/2 flex flex-col items-center justify-center">
      <h1 class="hidden md:block mb-0 text-center text-white">Connect</h1>
      <h2 class="md:hidden mb-0 text-center text-white">Connect</h2>
      <h3 class="text-white text-center mb-0">|</h3>
      <h1 class="hidden md:block mb-0 text-center text-white">Educate</h1>
      <h2 class="md:hidden mb-0 text-center text-white">Educate</h2>
      <h3 class="text-white text-center mb-0">|</h3>
      <h1 class="hidden md:block mb-12 text-center text-white">Inspire</h1>
      <h2 class="md:hidden mb-12 text-center text-white">Inspire</h2>
      <p class="text-center text-white px-0 lg:px-16">
      Involving the school community in career education benefits students
      by offering real-world insights and diverse career options. This
      engagement makes learning relevant, provides mentorship, and helps
      students gain confidence and clarity in their career paths, better
      preparing them for the future.
      </p>
      </div>
      </div> 
    -->
    <!-- /Connect Educate Inspire -->

    <!-- Features -->
    <!--
      <div class="pt-16 lg:pt-32 pb-8 px-8 flex flex-col items-center">
      <h2 class="text-cw-900 text-cente m-0">Features</h2>
      </div>
      <div class="bg-cw-50 flex items-center justify-center">
      <div class="max-w-6xl">
      <CardGroup :list="LIST_FEATURES" />
      </div>
      </div> 
    -->
    <!-- /Features -->

    <!-- School List -->
    <div class="overflow-hidden">
      <SchoolList />
    </div>
    <!-- /School List -->

    <!-- Get in Touch -->
    <div
      class="flex flex-col items-center justify-center w-full md:px-16 py-16 pb-20"
    >
      <div
        class="flex flex-wrap lg:flex-nowrap w-full max-w-6xl rounded-none md:rounded-4xl bg-cw-700 px-8 py-24 sm:p-0 text-white relative overflow-hidden"
      >
        <div
          class="w-full lg:w-7/12 relative sm:p-24 pb-0 lg:py-24 flex flex-col justify-center"
        >
          <img
            :style="[{ left: '-30%' }, { bottom: '-30%' }]"
            class="absolute w-full lg:w-10/12 opacity-10"
            src="/img/cw-shapes_dots_pink.png"
            alt="CW alt shapes"
          />
          <div class="flex flex-col items-start relative">
            <h1>Get in touch!</h1>
            <p class="mb-12 text-left">
              Got questions? Want to find out more, see a demo or sign up?
            </p>
            <button
              class="m-0 btn btn-cw-alt font-nunito shadow-lg"
              @click="toggleCwRegistration(0)"
            >
              Contact Us
            </button>
          </div>
        </div>
        <div
          class="hidden lg:block w-full lg:w-5/12 pt-12 px-0 sm:px-24 sm:pt-0 lg:pl-0 lg:py-24"
        >
          <div class="flex flex-col h-auto bg-white px-4 rounded-2xl">
            <img src="/img/cw-marketing/rocket.png" alt="Illustration rocket" />
          </div>
        </div>
      </div>
    </div>
    <!-- /Get in Touch -->
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import { EventBus } from '../../../js/plugins/event-bus.js'
import CardGroup from '../components/CardGroup.vue'
import CardGroupHover from '../components/CardGroupHover.vue'
import SchoolList from '../components/SchoolList.vue'

export default defineComponent({
  name: 'Connections',
  components: { CardGroup, CardGroupHover, SchoolList },

  setup() {
    const PX_CLASS = 'px-12 lg:px-32 2xl:px-64'

    const LIST_WHO_ITS_FOR = [
      {
        title: 'Schools',

        string:
          'Connections empowers schools by enhancing parent involvement and expanding school networks.',

        // text: 'CareerWise Connections empowers schools by enhancing parent involvement and expanding their network with a nationwide pool of resources. Additionally, it streamlines reporting, helping schools assess and improve their community engagement efforts, aligning with National Education Learning Priorities and ultimately preparing students better for future success!',
        cta: {
          text: 'Enquire',
          route: 'enquire',
        },
      },
      {
        title: 'Parents',

        string:
          'Connections empowers schools by enhancing parent involvement and expanding school networks',

        // text: 'Parents are key in CareerWise Connections. Through a straightforward form, they can become school connections, providing various support like mentoring, presentations, work experience, sponsorship, sports coaching, and more. Your involvement has the power to shape the future workforce and strengthen the school community',
        cta: {
          text: 'Enquire',
          route: 'enquire',
        },
      },
      {
        title: 'Tertiary institutions',

        string:
          "Education providers can directly inspire a national network of New Zealand's senior students.",

        // text: 'Becoming a nationwide connection in CareerWise Connections offers businesses and education providers valuable benefits. You gain direct access to a wide network of New Zealand schools, facilitating collaborations and talent connections. Your involvement helps shape a skilled workforce and aligns with the National Educational Learning Priorities, positively impacting both education and industry!',
        cta: {
          text: 'Enquire',
          route: 'org',
        },
      },
      {
        title: 'Employers and trade associations',

        string:
          'Employers can highlight the range of opportunities available at their organisation and within their sector.',

        // text: 'Becoming a nationwide connection in CareerWise Connections offers businesses and education providers valuable benefits. You gain direct access to a wide network of New Zealand schools, facilitating collaborations and talent connections. Your involvement helps shape a skilled workforce and aligns with the National Educational Learning Priorities, positively impacting both education and industry!',
        cta: {
          text: 'Enquire',
          route: 'org',
        },
      },
    ]

    const FEATURES_CHIPS = {
      SCHOOL: { text: 'schools', class: 'bg-cw-300' },
      PARENT: { text: 'parents', class: 'bg-cw-700' },
      ORG: { text: 'organisations', class: 'bg-cw-alt' },
    }
    const FEATURE_IMAGE_CLASS = 'h-48'

    const LIST_FEATURES = [
      {
        title: 'Police Check',
        text: "In certain situations, if a student is to be left alone with a mentor, it is the school's responsibility to conduct a police check to ensure a safe learning environment. Schools can indicate that a connection has been 'police checked' and they will receive a badge. This helps other teachers in your school know that this connection has undergone a police check.",
        image: '/img/cw-marketing/features-police.png',
        imageClass: FEATURE_IMAGE_CLASS,
        chips: [FEATURES_CHIPS.SCHOOL],
      },
      {
        title: 'Leads for organisations',
        text: 'Want to attract students to your industry or higher education? Sign up to be a CareerWise Connection and join a database so that students and parents can easily access your information and contact you. Your details are also put in front of School Career Advisors who may want to engage you in some kind of class presentation or interaction.',
        image: '/img/cw-marketing/features-leads.png',
        imageClass: FEATURE_IMAGE_CLASS,
        chips: [FEATURES_CHIPS.ORG],
      },
      {
        title: 'Education Providers & Businesses',
        text: 'Becoming a nationwide connection in CareerWise Connections offers businesses and education providers valuable benefits. You gain direct access to a wide network of New Zealand schools, facilitating collaborations and talent connections. Your involvement helps shape a skilled workforce and aligns with educational priorities, positively impacting both education and industry.',
        image: '/img/cw-marketing/features-orgs.png',
        imageClass: FEATURE_IMAGE_CLASS,
        chips: [FEATURES_CHIPS.ORG],
      },
      {
        title: 'Reporting',
        text: 'Get an overview of all logged engagements, including the learning areas they relate to, the year groups involved, the types of engagements, and more! Just choose your filters, and a graph will be generated for you. This helps identify trends and pinpoint areas where the school could engage more effectively.',
        image: '/img/cw-marketing/features-reporting.png',
        imageClass: FEATURE_IMAGE_CLASS,
        chips: [FEATURES_CHIPS.SCHOOL],
      },
      {
        title: 'Curate your own Connections',
        text: 'Save or establish connections with a curated list! Each school has its own unique sign-up form that can be shared with parents and community members, inviting them to join. Schools can view all their connections, both locally and nationwide; access their details and engagement preferences; and send direct messages - all from their dashboard!',
        image: '/img/cw-marketing/features-connections.png',
        imageClass: FEATURE_IMAGE_CLASS,
        chips: [FEATURES_CHIPS.SCHOOL],
      },

      {
        title: 'Simple forms and an up-to-date database',
        text: 'Signing up to be a connection is quick and easy! Simply fill out a multi-choice form to enter your details, preferences, and bio. We also keep your information current by checking in every 6 months to confirm your details and interest in remaining a connection. This ensures our database is always up to date.',
        image: '/img/cw-marketing/features-forms.png',
        imageClass: FEATURE_IMAGE_CLASS,
        chips: [FEATURES_CHIPS.PARENT, FEATURES_CHIPS.ORG],
      },
    ]

    const LIST_USER_TYPES = [
      {
        context: 'Schools',
        title1: 'A Stronger School Community',
        text1:
          'Connections enhances parent engagement and strengthens your school’s network by making it easy for parents and organizations to get involved. The feature empowers schools to foster a supportive community where everyone contributes to student growth and achievement.',
        image1: '/img/cw-marketing/connections-used-by-whole-school.jpg',
        cta1: 'Request a demo',

        title2: 'Detailed reports',
        text2:
          "We've also built in streamlined reporting so that users can log interactions with connections as well as  track engagement across subjects and year groups.  This helps schools monitor progress in meeting National Education Learning Priorities, especially Objective 4: Future of Learning and Work—ensuring learners gain skills, knowledge, and pathways to succeed in work.",
        image2: '/img/cw-marketing/connections-used-by-reports.jpg',

        title3: 'Empower Students Through Real Connections',
        text3:
          'With Connections, your students can now access an exclusive school network of parents and professionals ready to share their career journeys, insights, and advice. This powerful tool helps students build meaningful connections, gain valuable career inspiration, and start their path to success.',
        image3: '/img/cw-marketing/connections-used-by-meaningful.jpg',
      },

      {
        context: 'Parents',
        title1: 'A community approach',
        text1:
          "Parents play a vital role in education. Through CareerWise Connections, all parents within a school community have the option to support students' career discovery.  This could be minimal engagements such as being available for career questions via email to coming into school to present to classes.  Parents have been supporting schools in this way for years  but as a haphazard process with only a handful of parents taking part and known to the teacher. Connections widens the opportunity to all willing parents and their broader career choices which means students will be served with more opportunity, more role models, and a diversity of career options to explore.",
        image1: '/img/cw-marketing/connections-used-by-community.jpg',
        cta1: 'Get in touch',

        title2: 'Choose your preferences',
        text2:
          "Sign up on your terms.  You can select the preferences that suit you, whether it's participating in a webinar or avoiding in-person presentations. Tick the options that apply and choose your preferred contact methods. Support the school in a way that fits your schedule and interests.",
        image2: '/img/cw-marketing/connections-used-by-preferences.png',

        title3: "Support your child's school",
        text3:
          "Other people are the major influencers of our next generations' career pathway decisions. Connections opens the school network to help our next generation get inspired, achieve their full potential, and lead rich and satisfying lives.",
        image3: '/img/cw-marketing/connections-used-by-support.jpg',
      },

      // {
      //   context: 'Organisations',
      //   title1: 'Better connect with schools',
      //   text1:
      //     'Joining CareerWise Connections nationwide offers businesses and educational providers the opportunity to get in front of high school students contemplating career and study pathways. With Connections, you can showcase your services to tens of thousands of students and parents, highlighting staff available for career guidance. This exposure makes your organization stand out, ready to engage directly with students and parents, shaping a skilled workforce, and aligning with National Educational Standards.',
      //   image1: '/img/cw-marketing/connections-used-by-connect.jpg',

      //   title2: 'Promote your organisation',
      //   text2:
      //     'Promote your business on CareerWise to increase awareness and provide valuable industry insights. Help students explore diverse career paths and introduce new opportunities they might not have considered.',
      //   image2: '/img/cw-marketing/connections-used-by-promote.jpg',

      //   title3: 'Generate engagement & leads',
      //   text3:
      //     'Join us and enhance your business visibility among 100+ schools. Your details will be accessible to over 300 secondary school career advisors and over 100,000 students and parents through our CareerWise websites and newsletters, boosting your lead generation opportunities.',
      //   image3: '/img/cw-marketing/connections-used-by-leads.jpg',
      // },
    ]

    const PAGE_TITLE = 'Unlock the full potential of your school network'
    const SECTION_TITLE_HEAD_START = 'Give your students a head start'
    const SECTION_TITLE_CONNECT = 'Ways to Connect'
    const SECTION_TITLE_PEOPLE = 'Build a stronger school community'
    const SECTION_TITLE_REPORT = 'This is why we created CareerWise Connections'

    const registerSection = ref(null)
    const scrollTo = (section) => {
      window.scrollTo({
        // 80 is height of CW menu
        top: section?.offsetTop - 80,
        behavior: 'smooth',
      })
    }

    const register = (type) => {
      const MODAL_ACTION_MAP = {
        organisation: 'cw-organisation-registration',
        parent: 'cw-co-parent-registration',
      }

      EventBus.$emit('showModal', {
        action: MODAL_ACTION_MAP[type],
      })
    }

    const activeUserType = ref(0)
    const activeUserTypeData = computed(() => {
      return LIST_USER_TYPES[activeUserType.value]
    })

    const isActiveUserTypeParents = computed(() => activeUserType.value === 1)

    const userTypeDropdownActive = ref(false)
    const userTypeContentActive = ref(true)

    const toggleUserTypeDropdown = () => {
      userTypeDropdownActive.value = !userTypeDropdownActive.value
    }
    const selectUserType = (index) => {
      userTypeContentActive.value = false
      setTimeout(() => {
        activeUserType.value = index
        userTypeContentActive.value = true
      }, 800)
    }

    // Type of enquiry: 0 === information, 1 === demo, 2 === sign up, 3 === upgrade plan, 4 === other, 5 === Hail
    const toggleCwRegistration = (reason) => {
      EventBus.$emit('showModal', {
        action: 'cw-registration',
        data: {
          reason,
        },
      })
    }

    return {
      // DATA
      PX_CLASS,
      LIST_WHO_ITS_FOR,
      LIST_FEATURES,
      LIST_USER_TYPES,
      PAGE_TITLE,
      SECTION_TITLE_HEAD_START,
      SECTION_TITLE_CONNECT,
      SECTION_TITLE_PEOPLE,
      SECTION_TITLE_REPORT,

      registerSection,
      scrollTo,
      register,

      activeUserType,
      activeUserTypeData,
      isActiveUserTypeParents,
      userTypeDropdownActive,
      userTypeContentActive,
      toggleUserTypeDropdown,
      selectUserType,
      toggleCwRegistration,
    }
  },
})
</script>

<style scoped>
h1,
h2,
h3,
h4 {
  font-family: Montserrat;
}
h5,
h6,
p,
button {
  font-family: Nunito;
}
h1 {
  font-weight: 900;
  font-size: 4rem;
}
h2 {
  font-size: 3rem;
  font-weight: 900;
}
h3 {
  font-size: 2rem;
  font-weight: 700;
}
h4 {
  font-size: 1.25rem;
  font-weight: 700;
}
h5 {
  font-size: 0.875rem;
  font-weight: 700;
}

.btn {
  font-family: Nunito;
  font-size: 1rem;
  cursor: pointer;
}
.scoped-hero-bg {
  background: linear-gradient(
    145deg,
    rgba(101, 31, 255, 1) 0%,
    rgba(101, 31, 255, 1) 40%,
    rgba(255, 71, 120, 1) 100%
  );
}

.overlay {
  border-image: linear-gradient(hsla(0, 0%, 0%, 0.6), hsla(0, 0%, 0%, 0.6)) fill
    1;
}

.overlay-40 {
  border-image: linear-gradient(hsla(0, 0%, 0%, 0.6), hsla(0, 0%, 0%, 0.4)) fill
    1;
}

.black-bottom-overlay {
  border-image: linear-gradient(
      180deg,
      hsla(0, 0%, 0%, 0),
      hsla(0, 0%, 0%, 0.2),
      hsla(0, 0%, 0%, 0.8)
    )
    fill 1;
}
</style>
